const jobsCalendar = {
  view: 'תצוגה',
  calendarView: {
    monthly: 'חודשי',
    weekly: 'שבועי',
  },

  modalRemoveConfirm: {
    header: 'אזהרה!',
    bodySingle: 'האם אתה בטוח שברצונך למחוק הזמנה זו?',
    bodyMultiple: 'האם אתה בטוח שברצונך למחוק הזמנות אלה?',
    confirmBtn: 'מחק',
  },

  calendarTable: {
    actions: {
      delete: 'מחק'
    },
    cells: {
      dayOff: 'יום חופשי',
    },
    headers: {
      name: 'שם',
      monday: 'יום שני {{day}}',
      tuesday: 'יום שלישי {{day}}',
      wednesday: 'יום רביעי {{day}}',
      thursday: 'יום חמישי {{day}}',
      friday: 'יום שישי {{day}}',
      saturday: 'יום שבת {{day}}',
      sunday: 'יום ראשון {{day}}',
    },
  },

  filters: {
    students: 'תלמידים',
    caregivers: 'מטפלים',
  }, 

  shiftsFilter:{
    all:'כל הנוסעים',
    withShift: 'נוסעים עם משמרות',
    withoutShifts: 'נוסעים ללא משמרות',
  },
};

export default jobsCalendar;